module.exports = __webpack_public_path__ + "static/pandesal-d42f48f7d0dc24b644b8008473399d55.jpg";